import { render, staticRenderFns } from "./generalList.vue?vue&type=template&id=880c5ab6&"
import script from "./generalList.vue?vue&type=script&lang=js&"
export * from "./generalList.vue?vue&type=script&lang=js&"
import style0 from "./generalList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports